export default __webpack_public_path__ + "static/media/reebok_stimuli_phone.92494160.mp4";